export const getProfileImageUrl = (user: {
  metadata?: { twitter?: { profile_image_url?: string } }
}) => {
  const profile_image_url = user?.metadata?.twitter?.profile_image_url

  // this returns the original image url of the Twitter profile
  return profile_image_url
    ? profile_image_url.replace('_normal.', '.')
    : '/img/zapepe-circle.png'
}
